module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_2.4554442d.png";